import React, { useState } from 'react';
import Button from '../Button';
import { post } from '../Auths/AuthToken';
import { useDispatch, useSelector } from 'react-redux';
// import { setAllData } from '../../redux/slices/patient/customCounsellingOneSlice';
function AddCatagoryInCounsellingPopup({
  cancelLable,
  editCategoryData,
  providerId,
  setAllData,
  allData,
  type,
}) {
  const [labelName, setLabelName] = useState(editCategoryData?.labelName || '');
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  // const { allData } = useSelector((store) => store.customCounsellingOne);
  const addLableName = async () => {
    try {
      const response = await post('api/patient/progressNote/addEditLableName', {
        id: editCategoryData?.id,
        labelName: labelName,
        staffUserId: user?.id,
        type: type,
        providerId: providerId,
      });
      if (response.status === 200) {
        if (editCategoryData?.id) {
          dispatch(
            setAllData({
              ...allData,
              therapyMasterData: allData?.therapyMasterData?.map((item) => {
                if (item[0] === editCategoryData?.id) {
                  return [item[0], labelName, item[2], item[3], item[4]];
                }
                return item;
              }),
            })
          );
        } else {
          dispatch(
            setAllData({
              ...allData,
              therapyMasterData: [
                ...(allData?.therapyMasterData || []), // Safely spread the existing array
                [
                  response?.data?.id,
                  response?.data?.labelName,
                  [],
                  response?.data?.catagory,
                  '',
                ], // Append the new entry
              ],
            })
          );
        }
        cancelLable();
      }
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <div className="modalBackground">
      <div id="labelUpdateBlock" className="preferd-pharmacy-edit-main-block">
        <div className="prefrd-pharmcy-edit-header">
          <span className="prefrd-pharmcy-edit-name">Label</span>
          <Button variant="circle" onClick={cancelLable}>
            X
          </Button>
        </div>
        <div className="form-bg-color">
          <div className="prefrd-pharmcy-edit-body-row">
            <span className="pharmcy-edit-body-row-label">Name:</span>
            <span
              className="pharmcy-edit-body-row-value"
              style={{ width: 'calc(100% - 66px)' }}
            >
              <input
                type="text"
                name="labelName"
                id="labelName"
                value={labelName}
                onChange={(e) => setLabelName(e.target.value)}
              />
            </span>
          </div>
        </div>
        <div className="prefrd-pharmacy-add-edit-button-row">
          <Button variant="primary" onClick={addLableName}>
            {editCategoryData?.id ? 'Update' : 'Add'}
          </Button>
          <Button variant="outline" onClick={cancelLable}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AddCatagoryInCounsellingPopup;
